<template>

    <div class="galaxy::common-canvas-editor-canvas-document-pageOverlay-OverviewRootBlockToolbar tw-shadow-md tw-absolute" :style="panelStyle">

        <div class="rounded-t-lg tw-text-black tw-flex tw-items-center top">

            <button type="button" :disabled="rootBlockIndex === false || rootBlockIndex == 0" @click="moveUp">
                <i class="fas fa-fw fa-angle-up"></i>
            </button>

            <button type="button" class="hover:tw-text-red-600" @click="remove">
                <i class="fas fa-fw fa-trash"></i>
            </button>

        </div>

    </div>

</template>

<script>

    export default {

        inject: [
            '$pageComponent',
        ],

        props: {
            panelStyle: Object,
        },

        methods: {

            moveUp()
            {
                // Swap
                this.rootCanvasBlocks.splice(this.rootBlockIndex - 1, 2, this.currentSelection.canvasBlock, this.rootCanvasBlocks[this.rootBlockIndex - 1]);
            },

            async remove()
			{
				// @ugly Use of window.top's Swal.
				// Abort due to user does not confirm?
				const {value: confirmed} = await window.top.Swal.fire({
					title: 'Weet u het zeker?',
					text: 'Weet u zeker dat u deze wenst te verwijderen?',
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Ja, verwijder',
					confirmButtonColor: '#f62d51',
					cancelButtonText: 'Annuleer',
				});

				if (!confirmed)
					return;

				//
				this.removeConfirmed();
			},

			removeConfirmed()
            {
                // @ugly Responsibility of editor component itself?
                // Delete element + Vue components. It will take some time before we have new HTML. We have experienced issues when we let the HTML exists until we received new HTML.
                let blockElement = this.selection.currentSelection.element;

                this.$pageComponent().removeVueComponents(blockElement, true);

				blockElement.remove();

				// Delete from data.
                this.rootCanvasBlocks.splice(this.rootBlockIndex, 1);

                // Unselect
                this.selection.setSelection(null);
            },

        },

        computed: {

            rootCanvasBlocks()
            {
                return this.$pageComponent().state.canvasVersion.canvas_blocks;
            },

            rootBlockIndex()
            {
                // This happens when we deleted a block and Vue will rerender. We aleady deleted the block in mem.
                if(!this.currentSelection.canvasBlock)
                    return false;

                // Get id of each root block.
                let rootCanvasBlockIds = _.map(this.rootCanvasBlocks, canvasBlock => canvasBlock.id);

                // Find child index.
                return rootCanvasBlockIds.indexOf(this.currentSelection.canvasBlock.id);
            },

            selection()
            {
                return this.$pageComponent()?.selection;
            },

            currentSelection()
            {
                return this.selection.currentSelection;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-document-pageOverlay-OverviewRootBlockToolbar {
        transform-origin: left top;

        button {
            @apply tw-bg-white tw-border-0 tw-outline-none tw-w-10 tw-h-10;

            &:hover {
                @apply tw-bg-gray-200 tw-cursor-pointer;
            }

            &[disabled] {
                cursor: not-allowed;
            }
        }

    }

</style>
